<div *ngIf="active">
  <div class="custom-control custom-checkbox">
    <input type="checkbox" class="custom-control-input" id="booleanToggleFilter" [(ngModel)]="booleanToggleFilterValue"
           (change)=booleanToggleFilterChanged()>
    <label for="booleanToggleFilter" class="custom-control-label">{{ booleanToggleFilterText }}</label>
  </div>
</div>
